export const UPDATE_SESSION = 'UPDATE_SESSION'
export const UPDATE_SHOP_BOX = 'UPDATE_SHOP_BOX'
export const ADD_BOXES = 'ADD_BOXES'
